import { Box, Container, Flex, Heading, Text, Grid } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Section } from '@/components/ui/core/Section/Section';

export const MaterialsSection: FC<{ children?: ReactNode }> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <Section variant="dimmed" h={{ base: '614px', xl: '500px' }}>
      <Container pt={16} pb={10}>
        <Grid h="full" templateColumns={{ base: 'none', xl: '1fr 1fr' }} templateRows={{ base: '1fr 1fr', xl: 'none' }}>
          <Box mb={{ base: 5, xl: 0 }} maxW="500px">
            <Heading fontSize={{ base: '4xl', md: '5xl' }}>{t('episodeMaterial.materials')}</Heading>
            <Box w="1rem" borderBottom="2px solid black" my={{ base: 4, md: 8 }} />
            <Text flex="1" pr={{ base: 0, xl: 20 }} fontSize="xl">
              {t('episodeMaterial.description')}
            </Text>
          </Box>
          <Flex justifySelf="center" h="full" alignItems="center">
            {children}
          </Flex>
        </Grid>
      </Container>
    </Section>
  );
};
